/**
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the Commercial License found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useLockedRows = _interopRequireDefault(require("./useLockedRows"));
var _default = {
  name: 'locked-rows',
  hook: _useLockedRows.default,
  defaultProps: function defaultProps() {
    return {};
  }
};
exports.default = _default;